import { dispatchClient } from '@dispatch/shared/services';
import { TaskStatus, TaskStatusRequest } from '@dispatch/shared/types';
import { useMutation, useQueryClient } from 'react-query';

type TaskStatusAction = Exclude<TaskStatus, 'notstarted'>;
type StatusMudationData = {
  status: TaskStatusAction;
  taskId: string;
  request?: TaskStatusRequest;
};

async function setTaskStatus(
  taskId: string,
  status: TaskStatusAction,
  request?: TaskStatusRequest
) {
  return dispatchClient.post(
    `dispatch/service/tasks/${taskId}/status/${status}`,
    request
  );
}

export function useSetTaskStatus(
  onSuccess?: () => void,
  onError?: () => void,
  onSettled?: () => void
) {
  const queryClient = useQueryClient();
  return useMutation(
    async (data: StatusMudationData) =>
      setTaskStatus(data.taskId, data.status, data.request),
    {
      onSuccess,
      onError,
      onSettled: (_data, _error, variables) => {
        onSettled && onSettled();

        queryClient.invalidateQueries(['task', variables.taskId]);
        queryClient.invalidateQueries(['taskEvents']);
        queryClient.invalidateQueries(['summaries']);
        queryClient.invalidateQueries(['infos']);
        queryClient.invalidateQueries(['schedule-data']);
        queryClient.invalidateQueries(['schedule-data-infinite']);
      },
    }
  );
}
